import { showError } from './utils';
import axios from 'axios';

export const API = axios.create({
  // 统一使用同域请求，由 Pages Function 反向代理转发（见 functions/api/proxy/）
  baseURL: '',
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    showError(error);
  }
);
